module.exports = __webpack_public_path__ + "static/media/Jc.25380835.png";